import {Code, CodeSnippet} from "../../common/code/types";
import {CSSProperties, HTMLAttributes, ReactNode, useEffect, useRef, useState} from "react";
import FancyCodeMetricsProvider, {useCodeMetrics} from "./FancyCodeMetricsProvider";
import {useTypedSelector} from "../../store";
import {useCodeStyle} from "../../hooks";

const renderCode = (code: CodeSnippet) => <FancyLineOfCode code={code} br/>;

const styled = (node: ReactNode, style?: CSSProperties, indent?: number, br: boolean = false) => {
    const indentStyle: CSSProperties = {marginLeft: indent, display: br || indent ? "block" : undefined}

    if (node === "") return br ? <span style={{display: "block"}}><br/></span> : null

    return <span style={{...style, ...indentStyle}}>{node}{/*br && <br/>*/}</span>
    /*if (indentStyle) {
        return <span style={{...style, ...indentStyle}}>{node}{/!*br && <br/>*!/}</span>
    } else {
        return <span>{node}{br && <br/>}</span>
    }*/
}

const FancyLineOfCode = ({code, br, indent, childrenAsLines}: {code: CodeSnippet, br?: boolean, indent?: number, childrenAsLines?: boolean}) => {
    const codeMetrics = useCodeMetrics();
    const codeStyle = useCodeStyle();
    const i = codeMetrics.indent * codeMetrics.charWidth;
    const hovered = useTypedSelector(state => state.nodes.hovered);

    if (!code) return null;

    if (typeof code === "string") {
        return styled(code, undefined, indent, br)

    } else if ("code" in code) {
        const highlight = "ref" in code && code.ref === hovered;
        const hasType = "type" in code;
        let style = hasType && code.type && codeStyle[code.type];
        const isBlock_ = hasType && code.type === "block";
        const isBlockBody = hasType && code.type === "body";

        if (highlight) style = {...style, background: "#007fff20", color: "#007fff", fontWeight: 700, borderRadius: 4}

        if (typeof code.code === "string") {
            return styled(code.code, style, isBlockBody ? (indent?? 0) + i : undefined, isBlock_ || isBlockBody);
        } else {
            return styled(<FancyLineOfCode code={code.code} childrenAsLines={isBlockBody}/>, style, isBlockBody ? (indent?? 0) + i : undefined);
        }

    } else if (Array.isArray(code)) {
        return <span>{code.map((snippet, i, a) => {
            return <><FancyLineOfCode code={snippet} indent={indent}/>{childrenAsLines && (i < a.length - 1) && <br/>}</>;
        })}{br && <br/>}</span>
    }

    return null;
}

const FancyCode = ({code, ...props}: { code: Code } & HTMLAttributes<HTMLDivElement>) => {
    const testRef = useRef<HTMLDivElement>(null);
    const [charWidth, setCharWidth] = useState<number>(0);
    const codeStyle = useCodeStyle()[""];

    useEffect(() => {
        if (testRef.current) {
            setCharWidth(testRef.current.getBoundingClientRect().width);
        }
    }, [testRef])

    const textStyleProps: CSSProperties = {
        textAlign: 'left',
        fontFamily: 'Roboto Mono',
        fontSize: 14,
        fontWeight: 400,
        ...props.style,
        ...codeStyle
    }

    return <>
        <div ref={testRef} style={{
            position: 'absolute',
            left: 0,
            top: 0,
            pointerEvents: "none",
            opacity: 0,
            ...textStyleProps
        }}>1</div>
        <div {...props} style={{
            ...textStyleProps
        }}>
            <FancyCodeMetricsProvider indent={2} charWidth={charWidth}>
                {code.map(renderCode)}
            </FancyCodeMetricsProvider>
        </div>
    </>
}

export default FancyCode;